// 供应商管理系统 - 常量定义

// 供应商等级（依据供应商管理实施细则第23条：A/B/C为合格供应商，D为不合格供应商）
export const SUPPLIER_GRADES = {
  A: { label: 'A级（合格供应商）', color: '#52c41a', tag: 'green' },
  B: { label: 'B级（合格供应商）', color: '#1890ff', tag: 'blue' },
  C: { label: 'C级（合格供应商）', color: '#faad14', tag: 'orange' },
  D: { label: 'D级（不合格供应商）', color: '#ff4d4f', tag: 'red' },
};

// 供应商类型
export const SUPPLIER_TYPES = [
  { value: 'main', label: '主营业务供应商' },
  { value: 'non_main', label: '非主营业务供应商' },
];

// 客商类型（企业/个人）
export const ENTITY_TYPES = [
  { value: 'enterprise', label: '企业' },
  { value: 'individual', label: '个人' },
];

// 业务类型（对齐供应商字段梳理文档：主营业务/非主营业务）
export const BUSINESS_TYPES = [
  { value: 'main', label: '主营业务供应商' },
  { value: 'non_main', label: '非主营业务供应商' },
];

// 企业类别
export const ENTERPRISE_CATEGORIES = [
  { value: 'manufacturer', label: '生产制造企业' },
  { value: 'trading', label: '贸易型企业' },
  { value: 'service', label: '服务型企业' },
  { value: 'tech', label: '科技研发企业' },
  { value: 'recycling', label: '再生资源企业' },
  { value: 'other', label: '其他' },
];

// 发票类型（对齐字段梳理文档）
export const INVOICE_TYPES = [
  { value: 'special_vat', label: '增值税专用发票' },
  { value: 'general_vat', label: '增值税普通发票' },
];

// 企业性质（对齐字段梳理文档）
export const ENTERPRISE_NATURES = [
  { value: 'private', label: '民营' },
  { value: 'joint_venture', label: '中外合资' },
  { value: 'foreign', label: '外资' },
];

// 常用级别（对齐字段梳理文档）
export const COMMON_LEVELS = [
  { value: 'most_common', label: '最常用' },
  { value: 'common', label: '常用' },
  { value: 'normal', label: '普通' },
];

// 客商属性（对齐字段梳理文档）
export const CUSTOMER_ATTRIBUTES = [
  { value: 'other', label: '其他' },
  { value: 'central_soe', label: '中央企业' },
  { value: 'local_soe', label: '地方国有企业' },
  { value: 'central_ministry', label: '中央部委' },
  { value: 'local_government', label: '地方政府' },
  { value: 'private_enterprise', label: '民营企业' },
];

// 客商规模
export const CUSTOMER_SCALES = [
  { value: 'large', label: '大型' },
  { value: 'medium', label: '中型' },
  { value: 'small', label: '小型' },
  { value: 'micro', label: '微型' },
];

// 供应商类别（对齐字段梳理文档②供应商信息）
export const SUPPLIER_CATEGORIES = [
  { value: 'waste_producer', label: '产废企业' },
  { value: 'recycling', label: '回收企业' },
  { value: 'cce_subsidiary', label: '中资环分子公司' },
];

// 税率选项
export const TAX_RATES = [
  { value: 0, label: '0%' },
  { value: 0.01, label: '1%' },
  { value: 0.03, label: '3%' },
  { value: 0.05, label: '5%' },
  { value: 0.06, label: '6%' },
  { value: 0.09, label: '9%' },
  { value: 0.13, label: '13%' },
];

// 分公司辖区
export const JURISDICTION_AREAS = [
  { value: 'east_china', label: '华东' },
  { value: 'central_china', label: '华中' },
  { value: 'south_china', label: '华南' },
  { value: 'north_china', label: '华北' },
  { value: 'southwest', label: '西南' },
  { value: 'northeast', label: '东北' },
  { value: 'northwest', label: '西北' },
];

// 经营状态
export const OPERATING_STATUS = [
  { value: 'normal', label: '正常' },
  { value: 'revoked', label: '吊销' },
  { value: 'cancelled', label: '注销' },
  { value: 'moved_out', label: '迁出' },
];

// 注册币种
export const REGISTERED_CURRENCIES = [
  { value: 'CNY', label: '人民币' },
  { value: 'USD', label: '美元' },
  { value: 'EUR', label: '欧元' },
  { value: 'HKD', label: '港币' },
];

// 国民经济分类
export const NATIONAL_ECONOMY_CATEGORIES = [
  { value: 'manufacturing', label: '制造业' },
  { value: 'wholesale_retail', label: '批发和零售业' },
  { value: 'construction', label: '建筑业' },
  { value: 'transportation', label: '交通运输、仓储和邮政业' },
  { value: 'tech_service', label: '科学研究和技术服务业' },
  { value: 'leasing_service', label: '租赁和商务服务业' },
  { value: 'env_protection', label: '生态保护和环境治理业' },
  { value: 'waste_recycling', label: '废弃资源综合利用业' },
  { value: 'metal_products', label: '金属制品业' },
  { value: 'other', label: '其他' },
];

// 主要供货区域
export const MAIN_SUPPLY_REGIONS = [
  { value: 'nationwide', label: '全国' },
  { value: 'east_china', label: '华东地区' },
  { value: 'south_china', label: '华南地区' },
  { value: 'north_china', label: '华北地区' },
  { value: 'central_china', label: '华中地区' },
  { value: 'southwest', label: '西南地区' },
  { value: 'northeast', label: '东北地区' },
  { value: 'northwest', label: '西北地区' },
];

// 常用银行
export const COMMON_BANKS = [
  { value: 'icbc', label: '中国工商银行' },
  { value: 'ccb', label: '中国建设银行' },
  { value: 'abc', label: '中国农业银行' },
  { value: 'boc', label: '中国银行' },
  { value: 'comm', label: '交通银行' },
  { value: 'psbc', label: '中国邮政储蓄银行' },
  { value: 'cmb', label: '招商银行' },
  { value: 'citic', label: '中信银行' },
  { value: 'ceb', label: '中国光大银行' },
  { value: 'spdb', label: '浦发银行' },
  { value: 'cmbc', label: '民生银行' },
  { value: 'other', label: '其他' },
];

// 省份列表（常用）
export const PROVINCES = [
  { value: 'beijing', label: '北京' },
  { value: 'shanghai', label: '上海' },
  { value: 'tianjin', label: '天津' },
  { value: 'chongqing', label: '重庆' },
  { value: 'guangdong', label: '广东' },
  { value: 'jiangsu', label: '江苏' },
  { value: 'zhejiang', label: '浙江' },
  { value: 'shandong', label: '山东' },
  { value: 'hebei', label: '河北' },
  { value: 'henan', label: '河南' },
  { value: 'sichuan', label: '四川' },
  { value: 'hubei', label: '湖北' },
  { value: 'hunan', label: '湖南' },
  { value: 'fujian', label: '福建' },
  { value: 'anhui', label: '安徽' },
  { value: 'liaoning', label: '辽宁' },
  { value: 'shaanxi', label: '陕西' },
  { value: 'jiangxi', label: '江西' },
  { value: 'heilongjiang', label: '黑龙江' },
  { value: 'jilin', label: '吉林' },
  { value: 'shanxi', label: '山西' },
  { value: 'yunnan', label: '云南' },
  { value: 'guizhou', label: '贵州' },
  { value: 'guangxi', label: '广西' },
  { value: 'gansu', label: '甘肃' },
  { value: 'hainan', label: '海南' },
  { value: 'inner_mongolia', label: '内蒙古' },
  { value: 'xinjiang', label: '新疆' },
  { value: 'ningxia', label: '宁夏' },
  { value: 'qinghai', label: '青海' },
  { value: 'tibet', label: '西藏' },
];

// 审批状态
export const APPROVAL_STATUS = {
  draft: { label: '草稿', color: 'default' },
  submitted: { label: '已提交', color: 'processing' },
  reviewing: { label: '审核中', color: 'processing' },
  approved: { label: '已通过', color: 'success' },
  rejected: { label: '已驳回', color: 'error' },
  pending_site: { label: '待现场考察', color: 'warning' },
  site_done: { label: '考察完成', color: 'blue' },
};

// 14种负面清单情形（对齐第26条）
export const VIOLATION_TYPES = [
  { value: 'annual_score_below_60', label: '供应商年度综合评价得分＜60分的不合格供应商' },
  { value: 'contract_breach_loss', label: '不履行或不当履行合同义务造成各级公司损失的' },
  { value: 'price_deception', label: '有价格欺骗行为的，或者采取不正当竞争手段的' },
  { value: 'unqualified_goods', label: '因故意、过失提供不合格货物或者服务的' },
  { value: 'quality_major_incident', label: '因供货质量问题导致重大经济损失或质量事故、一般及以上生产安全事故、一般及以上突发环境事件' },
  { value: 'loss_performance_capacity', label: '已丧失或可能丧失履约能力的' },
  { value: 'illegal_subcontracting', label: '违法、违规或违反合同约定进行转包、分包的' },
  { value: 'license_lending', label: '存在借照、挂靠等行为的' },
  { value: 'fraud_deception', label: '在与各级子企业合作过程中存在弄虚作假、欺诈行为' },
  { value: 'bribery_improper_means', label: '以威胁、利诱等不正当手段谋取中标或成交，向工作人员实施贿赂或提供其他利益的' },
  { value: 'bid_rigging', label: '在招标过程中串标、围标、联手哄抬价格' },
  { value: 'abusive_litigation', label: '虚假、恶意散播或滥用诉讼权，损害集团形象声誉' },
  { value: 'insider_business', label: '存在集团及下属公司人员控股、参股等围绕集团业务经商行为' },
  { value: 'other_violation', label: '其他违法违规行为' },
];

// 资格中止原因
export const SUSPENSION_REASONS = [
  { value: 'qualification_expired', label: '资质证书过期未更新' },
  { value: 'quality_issue', label: '产品质量问题未整改' },
  { value: 'delivery_delay', label: '多次交付延迟' },
  { value: 'financial_risk', label: '财务状况严重恶化' },
  { value: 'legal_dispute', label: '重大法律纠纷' },
  { value: 'compliance_fail', label: '合规检查未通过' },
  { value: 'active_request', label: '供应商主动申请中止' },
];

// 履约状态
export const EXECUTION_STATUS = {
  pending: { label: '待执行', color: 'default' },
  in_progress: { label: '执行中', color: 'processing' },
  completed: { label: '已完成', color: 'success' },
  delayed: { label: '已延迟', color: 'warning' },
  terminated: { label: '已终止', color: 'error' },
};

// 质量状态
export const QUALITY_STATUS = {
  qualified: { label: '合格', color: 'success' },
  unqualified: { label: '不合格', color: 'error' },
  conditional: { label: '有条件接收', color: 'warning' },
  pending: { label: '待检验', color: 'default' },
};

// 交付状态
export const DELIVERY_STATUS = {
  on_time: { label: '按时交付', color: 'success' },
  early: { label: '提前交付', color: 'blue' },
  delayed: { label: '延迟交付', color: 'warning' },
  partial: { label: '部分交付', color: 'orange' },
  not_delivered: { label: '未交付', color: 'error' },
};

// 检查类型
export const INSPECTION_TYPES = [
  { value: 'routine', label: '巡检' },
  { value: 'spot', label: '抽检' },
  { value: 'delivery', label: '交付验收' },
];

// 评价触发类型
export const EVAL_TRIGGER_TYPES = [
  { value: 'regular', label: '定期评价' },
  { value: 'irregular', label: '不定期评价' },
  { value: 'project', label: '项目评价' },
];

// 评价维度 — 主营业务供应商（依据供应商管理实施细则附件2-1）
export const EVAL_DIMENSIONS_MAIN = [
  { key: 'resource', label: '资源保障与稳定性', weight: 25 },
  { key: 'quality', label: '质量表现', weight: 30 },
  { key: 'contract', label: '合同履约与协同', weight: 25 },
  { key: 'integrity', label: '廉洁诚信', weight: 10 },
  { key: 'cost_service', label: '成本与服务', weight: 10 },
];

// 评价维度 — 非主营业务供应商（依据供应商管理实施细则附件2-2）
export const EVAL_DIMENSIONS_NON_MAIN = [
  { key: 'quality', label: '质量水平', weight: 30 },
  { key: 'contract', label: '合同履约', weight: 30 },
  { key: 'delivery', label: '交付能力', weight: 15 },
  { key: 'after_sales', label: '售后服务', weight: 15 },
  { key: 'price', label: '价格与成本', weight: 10 },
];

// 退出类型
export const EXIT_TYPES = [
  { value: 'suspension', label: '资格中止' },
  { value: 'voluntary', label: '主动退出' },
  { value: 'involuntary', label: '被动退出' },
];

// 风险类型
export const RISK_TYPES = [
  { value: 'quality', label: '质量风险' },
  { value: 'delivery', label: '交付风险' },
  { value: 'qualification', label: '资质风险' },
  { value: 'related_party', label: '关联方风险' },
  { value: 'financial', label: '财务风险' },
];

// 风险等级
export const RISK_LEVELS = {
  high: { label: '高风险', color: 'red' },
  medium: { label: '中风险', color: 'orange' },
  low: { label: '低风险', color: 'blue' },
};

// 组织架构（集团 → 二级板块 → 三级子公司 → 四级分公司）
// 扁平 + parent/level 结构；数据按子树汇总/下钻，审批下沉到二级、集团穿透监督
export const ORG_NODES = [
  // 集团（穿透监督）
  { value: 'group', label: '中国资源循环集团', shortLabel: '集团', parent: null, level: 1 },
  // 二级板块（审批单位）
  { value: 'seg_recycle', label: '资环链金再生资源公司', parent: 'group', level: 2 },
  { value: 'seg_metal', label: '中国资源循环集团电池有限公司', parent: 'group', level: 2 },
  { value: 'seg_battery', label: '中国资源循环集团绿色投资有限公司', parent: 'group', level: 2 },
  { value: 'seg_fiber', label: '中国资源循环集团机动车有限公司', parent: 'group', level: 2 },
  // 三级子公司（提报单位）
  { value: 'subsidiary_1', label: '马钢诚兴金属资源有限公司', parent: 'seg_recycle', level: 3 },
  { value: 'sub_ewaste', label: '辽宁吉和源再生资源有限公司', parent: 'seg_recycle', level: 3 },
  { value: 'subsidiary_4', label: '马钢智信资源科技有限公司', parent: 'seg_recycle', level: 3 },
  { value: 'sub_steel', label: '中资环链金鑫华再生资源有限公司', parent: 'seg_recycle', level: 3 },
  { value: 'subsidiary_3', label: '欧冶链金（萍乡）再生资源有限公司', parent: 'seg_recycle', level: 3 },
  { value: 'sub_newenergy', label: '山西瑞赛格废弃资源有限公司', parent: 'seg_recycle', level: 3 },
  { value: 'subsidiary_6', label: '河北格瑞恩再生资源有限公司', parent: 'seg_recycle', level: 3 },
  // 四级分公司（提报单位，叶子）
  { value: 'sub_east', label: '中资环链金鑫华再生（安徽）资源有限公司和县分公司', parent: 'sub_steel', level: 4 },
  { value: 'sub_central', label: '中资环链金鑫华（安徽）再生资源有限公司宣城分公司', parent: 'sub_steel', level: 4 },
];

// 叶子节点（三/四级单位）—— 供应商的合作单位/提报单位；保持向后兼容
export const SUBSIDIARIES = ORG_NODES.filter(
  (n) => !ORG_NODES.some((x) => x.parent === n.value)
).map((n) => ({ value: n.value, label: n.label }));

// 全部组织节点选项（含板块/集团，供驾驶舱标签、组织树展示等）
export const ALL_ORG_OPTIONS = ORG_NODES.map((n) => ({ value: n.value, label: n.label }));

// 准入类型（采购/准入品类）
export const ADMISSION_TYPES = [
  { value: 'goods', label: '货物' },
  { value: 'service', label: '服务' },
  { value: 'engineering', label: '工程' },
  { value: 'other', label: '其他' },
];

// 审批流程步骤（对齐第13条）—— ownerLevel/ownerLevelLabel 标注当前负责层级（仅展示用，不改数据流）
export const APPROVAL_STEPS = [
  { title: '提交申请', description: '供应商/采购人员提报准入资料', ownerLevel: 'submitter', ownerLevelLabel: '三/四级提报' },
  { title: '部门初审', description: '二级采购管理部门审查资料完整性', ownerLevel: 'level2', ownerLevelLabel: '二级初审' },
  { title: '合规审查', description: '二级组织形式评审或现场考察评审', ownerLevel: 'level2', ownerLevelLabel: '二级合规' },
  { title: '领导审批', description: '二级分管采购领导审批', ownerLevel: 'level2', ownerLevelLabel: '二级审批' },
  { title: '完成备案', description: '集团穿透监督/备案登记', ownerLevel: 'group', ownerLevelLabel: '集团监督' },
];

// 黑名单提报状态（"子公司"语义下沉为"二级公司"）
export const BLACKLIST_REQUEST_STATUS = {
  pending_subsidiary_approval: { label: '待二级公司审批', color: 'gold' },
  subsidiary_approved: { label: '二级生效/待集团应用', color: 'blue' },
  active: { label: '黑名单中', color: 'red' },
  rejected: { label: '已驳回', color: 'default' },
  appealing: { label: '申诉中', color: 'orange' },
  removed: { label: '已移出', color: 'green' },
};

// 黑名单发起角色
export const BLACKLIST_INITIATOR_ROLES = [
  { value: 'group', label: '集团直接' },
  { value: 'subsidiary', label: '成员单位提报' },
];

// 处罚期限（依据第26条：负面清单默认5年禁入期）
export const PENALTY_DURATIONS = [
  { value: '5_years', label: '5年（负面清单标准禁入期）', isDefault: true },
  { value: 'permanent', label: '永久禁入' },
];

// 根据处罚期限计算禁入截止日期
export function calculateBanEndDate(startDate, penaltyValue) {
  if (penaltyValue === 'permanent') return null;
  if (penaltyValue === '5_years') {
    const d = new Date(startDate);
    d.setFullYear(d.getFullYear() + 5);
    return d.toISOString().split('T')[0];
  }
  return null;
}

// 问题跟踪 - 整改步骤
export const RECTIFICATION_STEPS = [
  { title: '问题发现' },
  { title: '通知供应商' },
  { title: '整改中' },
  { title: '整改验收' },
  { title: '闭环' },
];

// ─── 供应商自助平台常量（对齐供应商管理实施细则） ───

// 注册资料类别 — 企业（非主营，对齐字段梳理文档⑥相关资料附件上传）
export const REG_DOCS_ENTERPRISE = [
  { key: 'business_license', label: '营业执照', required: true, maxFiles: 3, hint: '须加盖公章，载明注册资本、成立日期、经营范围' },
  { key: 'bank_account_proof', label: '银行开户证明', required: true, maxFiles: 2, hint: '须加盖公章' },
  { key: 'business_intro', label: '业务展开说明', required: true, maxFiles: 3, hint: '说明拟开展业务的范围、能力及合作意向' },
  { key: 'supplier_info_attachment', label: '供应商信息附件', required: false, maxFiles: 5, hint: '供应商类别相关证明材料' },
  { key: 'payment_bank_voucher', label: '付款银行凭证', required: false, maxFiles: 3, hint: '付款银行账户凭证' },
  { key: 'other', label: '其他资料', required: false, maxFiles: 5, hint: '采购管理部门可能要求的其他资料' },
];

// 注册资料类别 — 个人（非主营，对齐字段梳理文档①基本信息+②财务信息）
export const REG_DOCS_INDIVIDUAL = [
  { key: 'id_card_front', label: '身份证正面', required: true, maxFiles: 1, hint: '复印件须清晰可辨' },
  { key: 'id_card_back', label: '身份证背面', required: true, maxFiles: 1, hint: '复印件须清晰可辨' },
  { key: 'bank_voucher', label: '银行凭证照片', required: true, maxFiles: 2, hint: '本人名下有效的个人银行结算账户凭证' },
];

// 廉洁承诺条款（对齐第11条通用准入条件）
export const INTEGRITY_COMMITMENT_CLAUSES = [
  { key: 'legal_entity', text: '具备履行合同所必需的合法主体资格与经营权限' },
  { key: 'no_violation', text: '近三年内（或自成立以来）在经营活动中无重大违法、失信记录，未列入国家企业信用信息公示系统、信用中国等平台的严重失信名单' },
  { key: 'no_bribery', text: '近三年内（或自成立以来）无行贿犯罪记录' },
  { key: 'not_banned', text: '未被列入集团及上级单位发布的各类禁止合作名单' },
  { key: 'integrity', text: '承诺遵守集团廉洁诚信与合作要求' },
];

// 非主营业务供应商专用条件（对齐第12条第2款）
export const NON_MAIN_SPECIAL_CONDITIONS = [
  '类似项目业绩',
  '专业技术能力',
  '服务团队配置',
  '售后服务保障',
  '成本控制能力',
  '具有法律效力的相关代理授权文件',
];

// 资料提交规则（对齐附件1第5节）
export const DOC_SUBMISSION_RULES = [
  '所有提交的复印件资料均需加盖申请单位公章（法人/组织）或申请人签字（个人），并注明"与原件一致"',
  '申请方应对所提供资料的真实性、合法性、有效性承担全部法律责任',
  '如发现资料虚假，将直接取消准入资格，并可能列入不良行为记录',
  '采购管理部门有权根据具体情况，要求申请方补充提供其他必要的证明资料或进行现场考察核实',
];

// 异议反馈类型（扩展覆盖一期+二期需求）
export const OBJECTION_TYPES = [
  { value: 'admission', label: '准入异议', description: '对准入审查结果有异议', color: 'blue' },
  { value: 'evaluation', label: '评价异议', description: '对评价得分有异议', color: 'green' },
  { value: 'grading', label: '定级异议', description: '对供应商分级结果有异议', color: 'purple' },
  { value: 'blacklist', label: '黑名单异议/申诉', description: '对黑名单纳入决定有异议', color: 'red' },
  { value: 'suspension', label: '资格中止异议', description: '对资格中止决定有异议', color: 'orange' },
  { value: 'qualification', label: '资质审核异议', description: '对资质审核结果有异议', color: 'cyan' },
  { value: 'change_review', label: '变更审核异议', description: '对信息变更审核结果有异议', color: 'geekblue' },
  { value: 'other', label: '其他', description: '其他类型的异议或建议', color: 'default' },
];

// 准入流程步骤（对齐第13条：申请－审查－评审－审批－入库）
export const ADMISSION_FLOW_STEPS = [
  { title: '申请提交', description: '供应商提交准入申请及相关资料' },
  { title: '资料审查', description: '采购管理部门审查基础资料' },
  { title: '评审', description: '组织形式评审或现场考察评审' },
  { title: '领导审批', description: '评审结果报分管采购领导审批' },
  { title: '入库', description: '批准后录入统一管理平台' },
];

// 资质证照分组（对齐附件1分类）
export const QUALIFICATION_GROUPS = [
  { key: 'enterprise_cert', label: '企业证照', types: ['business_license'] },
  { key: 'industry_qual', label: '行业资质', types: ['safety_license', 'production_license', 'construction_qual', 'hazardous_license', 'recycling_license'] },
  { key: 'system_cert', label: '体系认证', types: ['iso9001', 'iso14001', 'iso45001'] },
  { key: 'financial_credit', label: '财务资信', types: ['financial_audit', 'credit_report', 'tax_certificate'] },
  { key: 'performance', label: '业绩证明', types: ['performance_record', 'tech_staff_cert', 'agency_authorization'] },
  { key: 'other', label: '其他', types: ['other'] },
];
